import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Grid, Card, Message, List, Header } from "semantic-ui-react";

import { check, login } from "../../actions/auth";
import LoginForm from "../forms/LoginForm";
import GuidePage from "./GuidePage";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  submit = async (data) => {
    let resp = await this.props.check(data);
    // console.log(!resp.user.isRegistered && !resp.user.entityUser);
    // Si no está registrado y es un medico
    if (!resp.user.isRegistered && !resp.user.entityUser) {
      this.props.history.push("/signup");
    }

    if (resp.user.isRegistered) {
      this.props.login(data).then((response) => {
        this.props.history.push("/");
      });
    }
  };

  render() {
    const { isRegistered } = this.props;
    const { executeRecaptcha } = this.props.googleReCaptchaProps || {};
    return (
      <Grid>
        <Grid.Column
          className="bacteriaColumn"
          mobile={16}
          tablet={16}
          computer={5}
        >
          <Link className="bacteria" to="/presignup">
            <div className="bacteriaDiv">
              <p id="gotUser">¿Aún no tiene usuario?</p>
              <p id="register">Regístrese!</p>{" "}
            </div>
          </Link>
        </Grid.Column>
        <Grid.Column
          className="logginSeparation"
          mobile={16}
          tablet={16}
          computer={6}
        >
          <Card fluid={true}>
            <Message attached>
              <Header size="medium">Inicie su sesión</Header>
            </Message>
            <Card.Content>
              <LoginForm isRegistered={isRegistered} submit={this.submit} executeRecaptcha={executeRecaptcha} />
            </Card.Content>
            <Message attached="bottom" warning>
              <List horizontal>
                <List.Item>
                  <Link to="/forgot_password">Restablecer contraseña</Link>
                </List.Item>
              </List>
            </Message>
          </Card>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={5}>
          <GuidePage />
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isRegistered: state.user.isRegistered,
  };
};

export default connect(mapStateToProps, { check, login })(withGoogleReCaptcha(LoginPage));
